export default import.meta.ROLLDOWN_FILE_URL_U8Ukt0IGnmEjbjYZm7pfsQ